import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { Button, Link } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useDispatch } from '@grandvisionhq/state';
import { useAppointments } from '../../../Appointments/hooks/useAppointments.js';
import { upcomingAppointmentView } from '../../../data-layer/appointments/actions.js';
import { usePreferredStore } from '../../hooks/use-preferred-store.js';
import { Appointment } from './components/Appointment/Appointment.js';
import { LoadingAppointment } from './components/Loading.js';

const UpcomingAppointments = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const dispatch = useDispatch();
    const { data: appointments , loading , error  } = useAppointments();
    var ref;
    const appointmentsLinkProps = (ref = useLink({
        route: 'me.appointments'
    })) !== null && ref !== void 0 ? ref : {};
    const { routes  } = useBloomreachPageRoutes();
    var ref1;
    const bookAppointmentRoute = (ref1 = routes['appointment-book']) !== null && ref1 !== void 0 ? ref1 : '';
    const { data , loading: storeLoading , error: storeError  } = usePreferredStore();
    const storeId = data === null || data === void 0 ? void 0 : data.storeCode;
    React.useEffect(()=>{
        if ((appointments === null || appointments === void 0 ? void 0 : appointments.length) && !loading && appointments[0]) {
            dispatch(upcomingAppointmentView(appointments[0]));
        }
    }, [
        appointments,
        dispatch,
        loading
    ]);
    const getBookAppointmentRoute = React.useCallback(()=>{
        if (!storeId || storeError) {
            return bookAppointmentRoute;
        }
        const qs = new URLSearchParams({
            storeId: String(storeId)
        }).toString();
        return `${bookAppointmentRoute}/what?${qs}`;
    }, [
        bookAppointmentRoute,
        storeId,
        storeError
    ]);
    if (loading || storeLoading) {
        return /*#__PURE__*/ React.createElement(LoadingAppointment, null);
    } else if (error || !appointments) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            title: getLabel('account.appointments.errors.fetchFailed'),
            className: "alert-m-default"
        });
    }
    const now = new Date();
    const upcomingAppointments = appointments.filter((a)=>a.startTime > now
    );
    if (upcomingAppointments.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "myaccount-profile-appointment"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "myaccount-profile-appointment__none-scheduled"
        }, getLabel('appointments.noAppointments.message')), /*#__PURE__*/ React.createElement(Button, {
            href: getBookAppointmentRoute(),
            caption: getLabel('appointments.bookAppointment'),
            size: "small",
            className: "myaccount-profile-appointment__button",
            variant: "outline"
        }));
    }
    const hasReservation = upcomingAppointments.some((a)=>a.isReservation
    );
    return /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-profile-appointment"
    }, getLabel('appointments.overview.message'), hasReservation && /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        title: getLabel('appointments.reservation.infoAlert.title'),
        className: "alert-m-default"
    }, getFormattedLabel('appointments.reservation.infoAlert.message', {
        parseHTML: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-profile-appointment__cards"
    }, upcomingAppointments.map((a)=>/*#__PURE__*/ React.createElement(Appointment, {
            appointment: a,
            key: a.id
        })
    )), /*#__PURE__*/ React.createElement("div", {
        className: "myaccount-profile-appointment__actions"
    }, /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, appointmentsLinkProps, {
        iconAfter: "chevron-right"
    }), getLabel('appointments.viewAll'))));
};

export { UpcomingAppointments as default };
//# sourceMappingURL=UpcomingAppointments.js.map
